import { render } from "./vitalsignreport.vue?vue&type=template&id=3f80a920&scoped=true"
import script from "./vitalsignreport.js?vue&type=script&lang=js"
export * from "./vitalsignreport.js?vue&type=script&lang=js"

import "./vitalsignreport.vue?vue&type=style&index=0&id=3f80a920&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f80a920"]])

export default __exports__